module.exports = __webpack_public_path__ + "media/images/img/tag_company/accenture_tag-007ba1f35f09bdfcd1ea0966f9422502.png";